import DirectorsConsentContentError from 'modules/Business/containers/DirectorsError/ContentConsent';

import {
  Box,
  Button,
  Grid,
  GridItem,
  IconArrowBack,
  IconInfoOutlined,
} from '@capitalise/ui-design-system';
import withOpenIntercom from 'HOC/withOpenIntercom';

export interface DirectorConsentErrorProps {
  onBack: () => void;
}

const DirectorConsentError = ({ onBack }: DirectorConsentErrorProps) => {
  const IntercomLink = withOpenIntercom(Button);
  return (
    <>
      <DirectorsConsentContentError />
      <Box
        position="fixed"
        bottom={0}
        left={0}
        backgroundColor="white"
        width="100%"
        paddingY="3xsmall"
        borderTop="1px solid"
        borderColor="grey-50"
        minHeight="3xlarge"
      >
        <Grid>
          <GridItem colSpan={4} />
          <GridItem colSpan={{ sm: 12, md: 12, default: 4 }}>
            <Box display="grid" alignItems="center" gridTemplateColumns="1fr 1fr" gridGap="3xsmall">
              <Button
                onClick={onBack}
                baseColor="green"
                size="large"
                leftIcon={<IconArrowBack />}
                fullWidth
              >
                Update details
              </Button>
              <IntercomLink
                baseColor="green"
                size="large"
                variant="outlined"
                fullWidth
                rightIcon={<IconInfoOutlined />}
              >
                Contact us for help
              </IntercomLink>
            </Box>
          </GridItem>
          <GridItem colSpan={4} />
        </Grid>
      </Box>
    </>
  );
};

export default DirectorConsentError;
